// extracted by mini-css-extract-plugin
module.exports = {"selectWrap":"ConfirmPayrollGroupModal__selectWrap--1Dpo8"};